import React, { useState } from "react";
import colis_service from "../services/colis-service";
import { formatDate } from "../utils/date-utils";

const Colis = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [colisData, setColisData] = useState(null);
  const [error, setError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      setError("Veuillez entrer un terme de recherche.");
      return;
    }

    setIsLoading(true);
    setError(null);
    setHasSearched(true);

    try {
      const response = await colis_service.get({ searchQuery });

      console.log("API Response:", response);

      if (response?.data?.length > 0) {
        setColisData(response.data);
      } else {
        setColisData([]);
      }
      setSearchQuery("");
    } catch (error) {
      console.error(
        "API Error:",
        error.response ? error.response.data : error.message
      );
      setError("Une erreur s'est produite lors de la recherche.");
      setColisData(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="main">
      <div className="d-flex justify-content-center">
        <div className="p-4">
          <h2 className="text-center text-primary fw-bold mb-3">
            SUIVRE LE STATUS DE VOTRE COMMANDE
          </h2>
          <label className="form-label">
            ENTRER LE TRACKING NUMBER, OU VOTRE NOM CLIENT / SHIPPING MARK
          </label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Entrez votre tracking number, nom ou shipping mark..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            disabled={isLoading}
          />
          <button
            className="btn btn-warning w-100 text-white"
            onClick={handleSearch}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Recherche...
              </>
            ) : (
              "Valider"
            )}
          </button>
        </div>
      </div>

      <div className="row mt-4 p-2">
        {isLoading ? (
          <p className="text-center text-primary">Recherche en cours...</p>
        ) : error ? (
          <p className="text-center text-danger">{error}</p>
        ) : !hasSearched || !colisData ? (
          <p className="text-center text-muted">
            Veuillez rechercher un colis.
          </p>
        ) : colisData.length === 0 ? (
          <p className="text-center text-warning">Aucun colis trouvé.</p>
        ) : (
          colisData.map((colis) => (
            <div className="col-md-3 p-3" key={colis.id}>
              <div className="card shadow-sm p-4">
                <h5 className="text-danger fw-bold">
                  Code client: {colis.client_code}
                </h5>
                <p>
                  <strong>Nom:</strong> {colis.user_name}
                </p>
                <p>
                  <strong>Numéro colis:</strong> {colis.colis_number}
                </p>
                <p>
                  <strong>Poids:</strong> {colis.weight} kg
                </p>
                <p>
                  <strong>Dimensions:</strong> {colis.dimension} m³
                </p>
                <p>
                  <strong>Prix:</strong> {colis.price} Ariary
                </p>
                <p>
                  <strong>Mode d'envoi:</strong>{" "}
                  <span className="text-success">{colis.sending_option}</span>
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span className="text-success fw-bold">{colis.status}</span>
                </p>
                <p>
                  <strong>Date de départ:</strong>{" "}
                  {formatDate(colis.departure_date)}
                </p>
                <p>
                  <strong>Date d'arrivée:</strong>{" "}
                  {formatDate(colis.arrival_date)}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Colis;
